/**
 * Loading Page Component
 * 
 * Displayed while authentication state is being initialized
 */

export default function LoadingPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="loading-spinner w-12 h-12 border-4 mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          5axis Core Management
        </h2>
        <p className="text-gray-600">
          Loading your session...
        </p>
      </div>
    </div>
  )
}
